import View from "./view";
import React from "react";

export default function Home() {
  return <View />;
}



// WEBPACK FOOTER //
// ./src/pages/Home/index.jsx